
//系统目录 / 采购退货 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 新建采购退货西药
export const addOutbound = (data) => {
    return request.post("/outpatient/docOut/addOutbound", data )
}
// 新建采购退货西房
export const addXYFOutbound = (data) => {
    return request.post("/outpatient/dugRetn/insert", data )
}
// 新建采购退货中药
export const addZYOutbound = (data) => {
    return request.post("/outpatient/purcRetn/addTcmOutbound", data )
}
// 新建采购退货中药房
export const addZYFOutbound = (data) => {
    return request.post("/outpatient/tcmRetn/addTcmDrugRetn", data )
}
// 新建采购退货卫材 
export const addWCOutbound = (data) => {
    return request.post("/outpatient/eisaiRetnDoc/insert", data )
}
/**
 * 
 * put
 *  
 */

// 修改采购退货西药
export const editdocOut = (data) => {
    return request.put("/outpatient/docOut", data )
}
// 修改采购退货西药房
export const editXYFdocOut = (data) => {
    return request.post("/outpatient/dugRetn/edit", data )
}
// 修改采购退货中药
export const editZYdocOut = (data) => {
    return request.post("/outpatient/purcRetn/editTcmOutbound", data )
}
// 修改采购退货中药房
export const editZYFdocOut = (data) => {
    return request.post("/outpatient/tcmRetn/editTcmDrugRetn", data )
}
// 修改采购退货卫材
export const editWCdocOut = (data) => {
    return request.post("/outpatient/eisaiRetnDoc/edit", data )
}
// 提交审核过单 => 采购退库西药
export const toRetnExamine = (data) => {
    return request.post("/outpatient/docOut/toRetnExamine", data)
}
// 提交审核过单 => 采购退库西药房
export const toXYFRetnExamine = (data) => {
    return request.post("/outpatient/dugRetn/toExamine", data)
}
// 提交审核过单 => 采购退中药
export const toZYRetnExamine = (data) => {
    return request.post("/outpatient/purcRetn/toRetnExamine", data)
}
// 提交审核过单 => 采购退中药房
export const toZYFRetnExamine = (data) => {
    return request.post("/outpatient/tcmRetn/toExamine", data)
}
// 提交审核过单 => 采购退库卫材
export const toRetnWCExamine = (data) => {
    return request.post("/outpatient/eisaiRetnDoc/toRetnExamine", data)
}
/**
 * 
 * get 
 *  
 */

// 删除退库草稿西药
export const deleteReturn = (params) => {
    return request.delete("/outpatient/docOut/deleteBy", { params })
    }
// 删除退库草稿中药
export const deleteZYReturn = (params) => {
    return request.get("/outpatient/purcRetn/deleteBy", { params })
    }
// 删除退库草稿卫材
export const deleteWCReturn = (params) => {
	return request.delete("/outpatient/eisaiRetnDoc/deleteEisaiRetn", { params })
	}
// 供应商列表
export const SupplierEntityList = (params) => {
    return request.get("/outpatient/selectSupplierEntityList", { params })
    }
// 用于选择采购选择药品
export const getWare = (params) => {
    return request.get("/outpatient/getWare", { params })
}
// 采购退货列表西药
export const shopReturnList = (params) => {
    return request.get("/outpatient/docOut/page", { params })
}
// 采购退货列表西药房
export const shopReturnListXYF = (params) => {
    return request.get("/outpatient/dugRetn/page", { params })
}
// 其他入库列表西药
export const getXYOther = (params) => {
    return request.get("/outpatient/getOther", { params })
}
// 其他入库列表中药
export const getZYOther = (params) => {
    return request.get("/outpatient/purctcmtable/getOther", { params })
}
// 采购退货列表中药
export const shopZYFReturnList = (params) => {
    return request.get("/outpatient/purcRetn/page", { params })
}
// 采购退货列表中药房
export const shopZYReturnList = (params) => {
    return request.get("/outpatient/tcmRetn/page", { params })
}
// 采购退货列表卫材 分页
export const shopWCReturnList = (data) => {
    return request.post("/outpatient/eisaiRetnDoc/page", data)
}
//  西药采购退货详情页
export const getRetnDetail = (params) => {
    return request.get("/outpatient/docOut/getRetnList", { params })
}
//  西药房采购退货详情页
export const getXYFRetnDetail = (params) => {
    return request.get("/outpatient/dugRetn/getDrugRetnList", { params })
}
//  中药采购退货详情页
export const getZYRetnDetail = (params) => {
    return request.get("/outpatient/purcRetn/getRetnList", { params })
}
//  中药房采购退货详情页
export const getZYFRetnDetail = (params) => {
    return request.get("/outpatient/tcmRetn/getTcmRetnList", { params })
}
//  卫材采购退货详情页
export const getWCRetnDetail = (params) => {
    return request.get("/outpatient/eisaiRetnDoc/eisaiRetnDetails", { params })
}
// 出库方式
export const getTretn = (params) => {
    return request.get("/outpatient/docOut/getTretn", { params })
}
// 新建退药，供应商
export const selectDropDownList = (params) => {
    return request.get("/outpatient/selectDropDownList", { params })
}
// 新建 调拨和退药，选择药品西药（西药库到药房）
export const selectDrug = (params) => {
    return request.get("/outpatient/docOut/selectDrug", { params })
}
// 新建 调拨和退药，选择药品西药（西药房到药库）
export const selectYFtoYKDrug = (params) => {
    return request.get("/outpatient/dpurcallocate/selectDugAllocateDrug", { params })
}

// 新建 调拨和退药，选择药品 中药（中药库到药房）
export const selectZYDrug = (params) => {
    return request.get("/outpatient/purcRetn/selectDrug", { params })
}
// 新建 调拨和退药，选择药品 中药（中药库到药房）
export const selectZYtoYKDrug = (params) => {
    return request.get("/outpatient/dpurctcmallocate/selectTcmDrugDug", { params })
}
// 卫材库出库-选择要出库的卫材
export const selectWCDrug = (data) => {
    return request.post("/outpatient/eisaiRetnDoc/selectRetnEisai", data)
}

// 西药出库点击加入
export const docOutJoin = (params) => {
    return request.get("/outpatient/docOut/join", { params })
}
// 西药房出库点击加入
export const docXYFOutJoin = (params) => {
    return request.get("/outpatient/dugRetn/join", { params })
}
// 中药出库点击加入
export const docOutZYJoin = (params) => {
    return request.get("/outpatient/purcRetn/join", { params })
}
// 中药房出库点击加入
export const docOutZYFJoin = (params) => {
    return request.get("/outpatient/tcmRetn/join", { params })
}
// 卫材出库点击加入
export const docOutWCJoin = (params) => {
    return request.get("/outpatient/eisaiRetnDoc/join", { params })
}
// 采购入库方式
export const getPutin = (params) => {
    return request.get("/outpatient/dugDoc/selectPutin", { params })
}
// 出库方式
export const selectOut = (params) => {
    return request.get("/outpatient/dugRetn/selectOut", {params})
}
/*
 * 
 * DELETE 
 *   
 */  

// 西药出库
export const docOutDel = (params) => {
    return request.delete("/outpatient/docOut/deleteBy", { params })
}
// 西药房出库
export const XYFdocOutDel = (params) => {
    return request.delete("/outpatient/dugRetn/deleteRetn", { params })
}
// 中药出库
export const docOutDelZY = (params) => {
    return request.delete("/outpatient/purcRetn/deleteBy", { params })
}
// 中药房出库
export const docOutDelZYF = (params) => {
    return request.delete("/outpatient/tcmRetn/deleteRetn", { params })
}

// 选择要出库的卫材
export const selectRetnEisai = (params) => {
    return request.post("/outpatient/eisaiRetnDoc/selectRetnEisai", { params })
}


// 暴露
export default{
	addOutbound,editdocOut,SupplierEntityList,getWare,docOutDel,toRetnExamine,
	shopReturnList,getTretn,getRetnDetail,
	selectDropDownList,selectDrug,docOutJoin
	
}